import { Form } from 'antd';
import { useContext } from 'react';

import { SCard } from 'app/components/StaycationUI';
import { MarkdownPreview } from 'app/components/commons/MarkdownPreview/MarkdownPreview';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';

import { Description } from './_components/Description';
import { ImportantInformation } from './_components/ImportantInformation';
import { Menu } from './_components/Menu';
import { Tagline } from './_components/Tagline';
import { TreatmentList } from './_components/TreatmentList';

export const Copywriting = () => {
  const { data: experienceCategories } = useExperiencesCategories();
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const formValues = Form.useWatch([], form);
  const categoryIdValue = Form.useWatch('categoryId', form);

  const selectedCategory = experienceCategories?.find(
    (category) => category.id === categoryIdValue
  );

  return (
    <div className="experience-form experience-copywriting-form-section">
      <SCard
        title="Copywriting"
        className="experience-form experience-copywriting-form"
      >
        <Tagline />
        <Description />
        {selectedCategory?.menu && <Menu />}
        {selectedCategory?.treatmentList && <TreatmentList />}
        <ImportantInformation />
      </SCard>
      {isEditMode && <MarkdownPreview values={formValues} />}
    </div>
  );
};
